module.exports = __webpack_public_path__ + "img/blue_075.74b82ed3.png";